import React from 'react';
import { CUSTOMIZE } from '../../../constants';
import { useLocation } from 'react-router';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import { useIsDesignV2 } from '../../../hooks/useIsDesignV2';
import { PULSE_VIEW_ID, trackPulseView } from '../../../analytics/pulseViewIds';

interface ICustomizeButton {
  item: any;
  handleSyncIngredients: (item: any) => void;
  setShowCustomizedOptions: (state: boolean) => void;
  getOrderButtonState: (type: string) => boolean;
  showModifierModal:() => void;
  disabled?: boolean
}

const CustomizeButton: React.FC<ICustomizeButton> = (props) => {
  const {
    item,
    handleSyncIngredients,
    setShowCustomizedOptions,
    getOrderButtonState,
    showModifierModal,
    disabled = false
  } = props;
  const location = useLocation();
  const isThisMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2()

  return (
    <React.Fragment>
      {item?.is_customizable ? (
        <>
          <button
            type="button"
            className={`btn btn-large outline d-none d-md-block ${isDesignV2 && "f-sm-s16"}`}
            onClick={(e) => {
              const isDisabled = getOrderButtonState(CUSTOMIZE)
              if (!isDisabled) {
                setShowCustomizedOptions(true);
                trackPulseView(PULSE_VIEW_ID.CUSTOMIZATION, {
                  page_path: location.pathname,
                });
              }
              e.stopPropagation();
            }}
            data-testid="customizeButton"
            disabled={disabled}
          >
            customize
          </button>
          <button
            type="button"
            className={`btn btn-large outline d-md-none ${isDesignV2 && "f-sm-s16"}`}
            onClick={() => {
              const isDisabled = getOrderButtonState(CUSTOMIZE)
              if( !isDisabled ) showModifierModal()
            }}
          disabled={disabled}
          >
            customize
          </button>
        </>
      ) : null}
    </React.Fragment>
  );
};

export default CustomizeButton;
